export default __webpack_public_path__ + "static/media/cardiovascular@3x.63bf97f3.jpg";